import { HourOfDay } from "@swivl-mono/types";
import { DateTime } from "luxon";

import { SelectableOption } from "./Shared";

export class OptionsHelper {
  static hoursOptionsLocalized(timezone?: string): SelectableOption[] {
    const localTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    const result: Array<{ label: string; value: string }> = [];

    // Iterate over the HourOfDay enum values
    for (const localTime of Object.values(HourOfDay)) {
      // Parse the local time
      const localDate = DateTime.fromFormat(localTime, "HH:mm", { zone: localTimezone });

      // Convert local time to UTC
      const utcDate = localDate.toUTC();
      const utcTime = utcDate.toFormat("HH:mm");

      // Format local time with AM/PM
      const formattedLocalTime = localDate.toFormat("hh:mm a");

      // Add the formatted object to the result array
      result.push({ label: formattedLocalTime, value: utcTime });
    }

    return result;

    // const result: Array<{ label: string, value: string }> = [];

    // // Iterate over the HourOfDay enum values
    // for (const localTime of Object.values(HourOfDay)) {
    //   // Parse the local time
    //   const localDate = parse(localTime, 'HH:mm', new Date());

    //   // Convert local time to UTC
    //   const utcDate = zonedTimeToUtc(localDate, localTimezone);
    //   const utcTime = format(utcDate, 'HH:mm');

    //   // Format local time with AM/PM
    //   const formattedLocalTime = format(localDate, 'hh:mm a');

    //   // Add the formatted object to the result array
    //   result.push({ label: formattedLocalTime, value: utcTime });
    // }

    // return result;
    //         // return [];
    //     // itterate all hours of the day in 24 hour format by half hour
    //     const utcOffset = new Date().getTimezoneOffset() / 60

    //     let hours = Object.values(HourOfDay).map((hour) => {
    //         const minutesAndHours = hour.split(':')
    //         // add the UTC offset to the hour
    //         let utcHour = parseInt(minutesAndHours[0]) + utcOffset
    //         // if the hour is greater than 24, subtract 24 to get the correct hour
    //         if (utcHour >= 24) {
    //             utcHour -= 24
    //         }
    //         // if the hour is less than 0, add 24 to get the correct hour
    //         if (utcHour < 0) {
    //             utcHour += 24
    //         }
    //         // convert the hour to a string
    //         let utcTime = utcHour.toString().padStart(2, '0') + ':' + minutesAndHours[1]

    //         let localTimeIn24HourFormat = utcHour;
    //         let amPm = 'AM';
    //         if (localTimeIn24HourFormat >= 12) {
    //             amPm = 'PM';
    //         }
    //         if (localTimeIn24HourFormat > 12) {
    //             localTimeIn24HourFormat -= 12;
    //         }
    //         if (localTimeIn24HourFormat === 0) {
    //             localTimeIn24HourFormat = 12;
    //         }
    //         const label = `${localTimeIn24HourFormat}:${minutesAndHours[1]} ${amPm}`;

    //         return {label:label,value:utcTime}

    // })

    //     return hours
  }
}
